const JH_URL_CONSTANTS = {
    JH_URL_PATH: '/rekyc/jointHolder',
    JH_URL_PATH_2: '/rekyc/jointHolder/secondary',

    JH_LANDING: '/servicing/rekyc-jointHolder',
    JH2_LANDING: '/servicing/vkycSecondary',
    JH_SUCCESS: '/servicing/rekycJHSuccess',
    JH_SECONDARY_MOBILE_VERIFICATION: '/servicing/vkycMobileVerify',
    JH_HOME: '/servicing/rekycJHhome',
    JH_DATA: '/servicing/rekycJHData',
    JH_ERROR_REDIRECT: '/servicing/rekycJHError',
}

export default JH_URL_CONSTANTS;